<script>
  import IntersectionObserver from "svelte-intersection-observer";
  import Grid from "./Grid.svelte";

  let element;
  export let intersecting = false;
</script>

<IntersectionObserver {element} bind:intersecting>
  <section bind:this={element} id="outcomes-intro">
    <div class="prose relative">
      <Grid isScrollytelling={true} />
    </div>
  </section>
</IntersectionObserver>

<style>
  section {
    text-align: left;
    padding: 5rem 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    place-items: center;
    border: 1px solid rgba(var(--text-color-rgb), 0.25);
  }

  .relative {
    position: relative;
  }

  /* .emoji-follows::before {
    top: -1rem;
    right: -5rem;
  } */
</style>
